<div class="am-bag-detail-content">
  <span>{{count}}</span>
  <div [ngSwitch]="bagWeight">
    <span *ngSwitchCase="BagsWeight._10KG">{{'bagsSelectionCarryon.detail-bags-weight.bags10Kg' | translate}}</span>
    <span *ngSwitchCase="BagsWeight._15KG">{{'bagsSelectionCarryon.detail-bags-weight.bags15Kg' | translate}}</span>
  </div>
</div>

